import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const announcementAPI = createApi({
  reducerPath: 'announcementAPI',
  baseQuery,
  tagTypes: ['Announcement'],
  endpoints: (builder) => ({
    getAnnouncement: builder.query({
      query: () => ({
        url: '/api/v1/admin/announcements',
        method: 'GET',
      }),
      providesTags: ['Announcement'],
    }),

    createAnnouncement: builder.mutation({
      query: (payload) => ({
        url: '/api/v1/admin/announcements',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Announcement'],
    }),

    updateAnnouncement: builder.mutation({
      query: (payload) => ({
        url: '/api/v1/admin/announcements',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Announcement'],
    }),
  }),
});

export const {
  useGetAnnouncementQuery,
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
} = announcementAPI;

export default announcementAPI;
